import { useCallback } from "react";
import { PROVIDER_PATH } from "../config";
import { clientUserAuthGate } from "../statsig/gates";
import { Statsig } from "../statsig/StatsigProvider";
import { AppState } from "@auth0/auth0-react";
import { useAppDependenciesContext } from "../state";
import { LOGIN_CALLBACK_PATH } from "../nav/config";

export function useAuthRedirectCallback() {
  const { useNavigate, logger } = useAppDependenciesContext();
  const navigate = useNavigate();

  return useCallback(
    ({
      appState,
      currentPath,
    }: {
      appState?: AppState;
      currentPath: string;
    }) => {
      const missingReturnToValue = !appState?.returnTo;
      const isClientUserAuthEnabled = Statsig.checkGate(clientUserAuthGate);

      if (missingReturnToValue && isClientUserAuthEnabled) {
        logger.error(
          "Redirected to login-callback URL without a return-to value",
        );
      }

      // Path to direct to if the return-to value is unexpectedly missing
      const fallbackPath =
        currentPath === LOGIN_CALLBACK_PATH ? PROVIDER_PATH : currentPath;

      // It's important that this is always called in order to remove the Auth0
      // URL query params
      navigate(appState?.returnTo || fallbackPath, {
        replace: true,
      });
    },
    [logger, navigate],
  );
}
